import axios from 'axios'
import {config} from '../config'
export const getAchievements = () =>{
    return axios.get(config.achievements)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

